
import { useScrollAnimation } from '../../../hooks/useScrollAnimation';

export function RemoteHelp() {
  const { ref, isVisible } = useScrollAnimation();

  return (
    <section id="ayuda-inmediata" className="py-20 bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 relative overflow-hidden">
      {/* Efectos de fondo */}
      <div className="absolute inset-0 opacity-20">
        <div className="absolute top-20 left-10 w-72 h-72 bg-rosa-500 rounded-full filter blur-3xl animate-pulse"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-cyan-500 rounded-full filter blur-3xl animate-pulse" style={{ animationDelay: '1s' }}></div>
      </div>

      <div ref={ref} className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className={`text-center max-w-3xl mx-auto anim-scale-in ${isVisible ? 'visible' : ''}`}>
          {/* Título principal */}
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
            ¿Solicita <span className="text-rosa-400">ayuda inmediata</span> ahora?
          </h2>

          {/* Leyenda descriptiva */}
          <p className="text-xl text-gray-300 mb-10 font-light">
            Te conectamos desde donde estás con quien tienes que estar
          </p>

          {/* Botón de descarga con efectos */}
          <div className="flex justify-center">
            <a
              href="https://anydesk.com/es"
              target="_blank"
              rel="noopener noreferrer"
              className="group relative inline-flex items-center gap-2 sm:gap-3 bg-gradient-to-r from-rosa-500 to-rosa-600 hover:from-rosa-600 hover:to-rosa-700 text-white px-5 sm:px-8 py-4 sm:py-5 rounded-full text-sm sm:text-lg font-semibold transition-all duration-300 transform hover:scale-105 hover:shadow-2xl shadow-rosa-lg whitespace-nowrap cursor-pointer btn-magnetic"
            >
              {/* Efecto de brillo animado */}
              <div className="absolute inset-0 rounded-full bg-gradient-to-r from-transparent via-white to-transparent opacity-0 group-hover:opacity-20 group-hover:animate-pulse"></div>
              
              {/* Icono de descarga */}
              <i className="ri-download-cloud-line text-2xl sm:text-3xl"></i>
              
              {/* Texto del botón */}
              <span className="relative z-10 text-xs sm:text-base">
                Descargue aquí nuestro remoto para clientes
              </span>
              
              {/* Flecha animada */}
              <i className="ri-arrow-right-line text-xl sm:text-2xl transform group-hover:translate-x-2 transition-transform duration-300"></i>
            </a>
          </div>

          {/* Información adicional */}
          <div className="mt-8 flex items-center justify-center gap-2 text-gray-400 text-sm">
            <i className="ri-shield-check-line text-cyan-400 text-xl"></i>
            <span>Conexión segura y encriptada integrarse con nuestros Software Anydesk</span>
          </div>
        </div>
      </div>
    </section>
  );
}
